<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M60.7176 56.1521L29.8558 47.7257C28.2362 47.2816 27.1614 46.2778 26.6315 44.7142C26.1016 43.1505 26.3405 41.7026 27.3443 40.3741L28.6206 38.6873C29.0833 38.0753 29.6655 37.5977 30.3596 37.2543C31.0574 36.911 31.7889 36.7543 32.5613 36.7841L64.2105 37.9261"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M86.9886 47.9421L99.7476 87.6483C99.9864 88.3834 100.035 89.1298 99.8931 89.8948C99.7513 90.6561 99.4491 91.3465 98.9863 91.9585L97.71 93.6452C96.7062 94.9737 95.3777 95.5932 93.7282 95.5074C92.0788 95.4216 90.8212 94.6603 89.9554 93.2198L73.4684 65.8024L62.3515 80.487L66.8147 94.4102C66.99 95.0185 67.0311 95.6193 66.9341 96.2202C66.837 96.821 66.6019 97.3695 66.2213 97.8733L64.8891 99.631C64.1166 100.654 63.0866 101.161 61.8029 101.161C60.5191 101.161 59.4929 100.631 58.7204 99.5788L48.4954 85.5398L32.2099 79.5093C30.9859 79.054 30.1984 78.2069 29.8514 76.9716C29.5006 75.7364 29.7133 74.6094 30.4858 73.5869L31.8255 71.8181C32.1987 71.3255 32.6577 70.9523 33.21 70.6985C33.7623 70.441 34.3519 70.3142 34.9863 70.3216L49.5962 70.8403"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M94.168 60.9511L94.7986 60.1189C95.5226 59.1599 96.8884 58.9733 97.8438 59.6972L98.0975 59.8876C99.0566 60.6115 99.2432 61.9774 98.5192 62.9327L96.1421 66.0711"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M99.875 77.3523L100.506 76.5201C101.23 75.561 102.595 75.3744 103.551 76.0984L103.805 76.2887C104.764 77.0127 104.95 78.3785 104.226 79.3338L101.849 82.4723"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M59.7678 34.9108L60.3985 34.0786C61.1225 33.1195 60.9359 31.7574 59.9768 31.0335L59.7231 30.8431C58.764 30.1192 57.4019 30.3058 56.6779 31.2648L54.3008 34.4033"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M42.4339 33.8696L43.0645 33.0374C43.7885 32.0784 43.6019 30.7163 42.6428 29.9923L42.3891 29.802C41.43 29.078 40.0679 29.2646 39.3439 30.2237L36.9668 33.3621"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M53.6008 72.2995C53.6008 72.2995 79.1485 16.1175 97.8298 20.3755C116.507 24.6335 84.9141 70.1014 29.8555 47.7257"
            class="accent-stroke"
            stroke-width="6.7172"
            stroke-miterlimit="10" />
        <path
            d="M54.3535 75.7289C52.6108 74.7438 50.4015 75.505 49.6365 77.356L44.7031 89.335L53.8609 78.7592"
            fill="white" />
        <path
            d="M54.3535 75.7289C52.6108 74.7438 50.4015 75.505 49.6365 77.356L44.7031 89.335L53.8609 78.7592"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M95.4789 27.7122L95.6505 27.8428C97.2365 29.0444 98.0351 30.8991 97.953 32.7463C99.4196 30.7498 99.0166 27.9398 97.035 26.4396L96.4566 25.9993C94.475 24.4991 91.6612 24.8723 90.1387 26.824C91.8963 26.2456 93.8966 26.5068 95.4826 27.7084L95.4789 27.7122Z"
            class="primary-fill primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M41.4613 93.3057C41.4613 93.3057 29.9898 107.819 28.9785 110.435"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M47.7083 92.7161C47.7083 92.7161 40.7298 101.934 38.7109 105.236"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M39.1825 86.7452C39.1825 86.7452 33.2937 93.8878 31.9727 96.2687"
            class="primary-stroke"
            stroke-width="1.30612"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
